export type CountryOption = {
  code: string;
  name: string;
  dialCode: string;
  flagUrl: string;
};

export const COUNTRY_OPTIONS: CountryOption[] = [
  {
    code: "AX",
    name: "Åland Islands",
    dialCode: "+358",
    flagUrl: "https://flagcdn.com/w20/ax.png",
  },
  {
    code: "AF",
    name: "Afghanistan",
    dialCode: "+93",
    flagUrl: "https://flagcdn.com/w20/af.png",
  },
  {
    code: "AL",
    name: "Albania",
    dialCode: "+355",
    flagUrl: "https://flagcdn.com/w20/al.png",
  },
  {
    code: "DZ",
    name: "Algeria",
    dialCode: "+213",
    flagUrl: "https://flagcdn.com/w20/dz.png",
  },
  {
    code: "AS",
    name: "American Samoa",
    dialCode: "+1",
    flagUrl: "https://flagcdn.com/w20/as.png",
  },
  {
    code: "AD",
    name: "Andorra",
    dialCode: "+376",
    flagUrl: "https://flagcdn.com/w20/ad.png",
  },
  {
    code: "AO",
    name: "Angola",
    dialCode: "+244",
    flagUrl: "https://flagcdn.com/w20/ao.png",
  },
  {
    code: "AI",
    name: "Anguilla",
    dialCode: "+1",
    flagUrl: "https://flagcdn.com/w20/ai.png",
  },
  {
    code: "AQ",
    name: "Antarctica",
    dialCode: "+672",
    flagUrl: "https://flagcdn.com/w20/aq.png",
  },
  {
    code: "AG",
    name: "Antigua and Barbuda",
    dialCode: "+1",
    flagUrl: "https://flagcdn.com/w20/ag.png",
  },
  {
    code: "AR",
    name: "Argentina",
    dialCode: "+54",
    flagUrl: "https://flagcdn.com/w20/ar.png",
  },
  {
    code: "AM",
    name: "Armenia",
    dialCode: "+374",
    flagUrl: "https://flagcdn.com/w20/am.png",
  },
  {
    code: "AW",
    name: "Aruba",
    dialCode: "+297",
    flagUrl: "https://flagcdn.com/w20/aw.png",
  },
  {
    code: "AU",
    name: "Australia",
    dialCode: "+61",
    flagUrl: "https://flagcdn.com/w20/au.png",
  },
  {
    code: "AT",
    name: "Austria",
    dialCode: "+43",
    flagUrl: "https://flagcdn.com/w20/at.png",
  },
  {
    code: "AZ",
    name: "Azerbaijan",
    dialCode: "+994",
    flagUrl: "https://flagcdn.com/w20/az.png",
  },
  {
    code: "BS",
    name: "Bahamas",
    dialCode: "+1",
    flagUrl: "https://flagcdn.com/w20/bs.png",
  },
  {
    code: "BH",
    name: "Bahrain",
    dialCode: "+973",
    flagUrl: "https://flagcdn.com/w20/bh.png",
  },
  {
    code: "BD",
    name: "Bangladesh",
    dialCode: "+880",
    flagUrl: "https://flagcdn.com/w20/bd.png",
  },
  {
    code: "BB",
    name: "Barbados",
    dialCode: "+1",
    flagUrl: "https://flagcdn.com/w20/bb.png",
  },
  {
    code: "BY",
    name: "Belarus",
    dialCode: "+375",
    flagUrl: "https://flagcdn.com/w20/by.png",
  },
  {
    code: "BE",
    name: "Belgium",
    dialCode: "+32",
    flagUrl: "https://flagcdn.com/w20/be.png",
  },
  {
    code: "BZ",
    name: "Belize",
    dialCode: "+501",
    flagUrl: "https://flagcdn.com/w20/bz.png",
  },
  {
    code: "BJ",
    name: "Benin",
    dialCode: "+229",
    flagUrl: "https://flagcdn.com/w20/bj.png",
  },
  {
    code: "BM",
    name: "Bermuda",
    dialCode: "+1",
    flagUrl: "https://flagcdn.com/w20/bm.png",
  },
  {
    code: "BT",
    name: "Bhutan",
    dialCode: "+975",
    flagUrl: "https://flagcdn.com/w20/bt.png",
  },
  {
    code: "BO",
    name: "Bolivia",
    dialCode: "+591",
    flagUrl: "https://flagcdn.com/w20/bo.png",
  },
  {
    code: "BA",
    name: "Bosnia and Herzegovina",
    dialCode: "+387",
    flagUrl: "https://flagcdn.com/w20/ba.png",
  },
  {
    code: "BW",
    name: "Botswana",
    dialCode: "+267",
    flagUrl: "https://flagcdn.com/w20/bw.png",
  },
  {
    code: "BV",
    name: "Bouvet Island",
    dialCode: "+47",
    flagUrl: "https://flagcdn.com/w20/bv.png",
  },
  {
    code: "BR",
    name: "Brazil",
    dialCode: "+55",
    flagUrl: "https://flagcdn.com/w20/br.png",
  },
  {
    code: "IO",
    name: "British Indian Ocean Territory",
    dialCode: "+246",
    flagUrl: "https://flagcdn.com/w20/io.png",
  },
  {
    code: "VG",
    name: "British Virgin Islands",
    dialCode: "+1",
    flagUrl: "https://flagcdn.com/w20/vg.png",
  },
  {
    code: "BN",
    name: "Brunei",
    dialCode: "+673",
    flagUrl: "https://flagcdn.com/w20/bn.png",
  },
  {
    code: "BG",
    name: "Bulgaria",
    dialCode: "+359",
    flagUrl: "https://flagcdn.com/w20/bg.png",
  },
  {
    code: "BF",
    name: "Burkina Faso",
    dialCode: "+226",
    flagUrl: "https://flagcdn.com/w20/bf.png",
  },
  {
    code: "BI",
    name: "Burundi",
    dialCode: "+257",
    flagUrl: "https://flagcdn.com/w20/bi.png",
  },
  {
    code: "KH",
    name: "Cambodia",
    dialCode: "+855",
    flagUrl: "https://flagcdn.com/w20/kh.png",
  },
  {
    code: "CM",
    name: "Cameroon",
    dialCode: "+237",
    flagUrl: "https://flagcdn.com/w20/cm.png",
  },
  {
    code: "CA",
    name: "Canada",
    dialCode: "+1",
    flagUrl: "https://flagcdn.com/w20/ca.png",
  },
  {
    code: "CV",
    name: "Cape Verde",
    dialCode: "+238",
    flagUrl: "https://flagcdn.com/w20/cv.png",
  },
  {
    code: "BQ",
    name: "Caribbean Netherlands",
    dialCode: "+599",
    flagUrl: "https://flagcdn.com/w20/bq.png",
  },
  {
    code: "KY",
    name: "Cayman Islands",
    dialCode: "+1",
    flagUrl: "https://flagcdn.com/w20/ky.png",
  },
  {
    code: "CF",
    name: "Central African Republic",
    dialCode: "+236",
    flagUrl: "https://flagcdn.com/w20/cf.png",
  },
  {
    code: "TD",
    name: "Chad",
    dialCode: "+235",
    flagUrl: "https://flagcdn.com/w20/td.png",
  },
  {
    code: "CL",
    name: "Chile",
    dialCode: "+56",
    flagUrl: "https://flagcdn.com/w20/cl.png",
  },
  {
    code: "CN",
    name: "China",
    dialCode: "+86",
    flagUrl: "https://flagcdn.com/w20/cn.png",
  },
  {
    code: "CX",
    name: "Christmas Island",
    dialCode: "+61",
    flagUrl: "https://flagcdn.com/w20/cx.png",
  },
  {
    code: "CC",
    name: "Cocos (Keeling) Islands",
    dialCode: "+61",
    flagUrl: "https://flagcdn.com/w20/cc.png",
  },
  {
    code: "CO",
    name: "Colombia",
    dialCode: "+57",
    flagUrl: "https://flagcdn.com/w20/co.png",
  },
  {
    code: "KM",
    name: "Comoros",
    dialCode: "+269",
    flagUrl: "https://flagcdn.com/w20/km.png",
  },
  {
    code: "CK",
    name: "Cook Islands",
    dialCode: "+682",
    flagUrl: "https://flagcdn.com/w20/ck.png",
  },
  {
    code: "CR",
    name: "Costa Rica",
    dialCode: "+506",
    flagUrl: "https://flagcdn.com/w20/cr.png",
  },
  {
    code: "HR",
    name: "Croatia",
    dialCode: "+385",
    flagUrl: "https://flagcdn.com/w20/hr.png",
  },
  {
    code: "CU",
    name: "Cuba",
    dialCode: "+53",
    flagUrl: "https://flagcdn.com/w20/cu.png",
  },
  {
    code: "CW",
    name: "Curaçao",
    dialCode: "+599",
    flagUrl: "https://flagcdn.com/w20/cw.png",
  },
  {
    code: "CY",
    name: "Cyprus",
    dialCode: "+357",
    flagUrl: "https://flagcdn.com/w20/cy.png",
  },
  {
    code: "CZ",
    name: "Czechia",
    dialCode: "+420",
    flagUrl: "https://flagcdn.com/w20/cz.png",
  },
  {
    code: "DK",
    name: "Denmark",
    dialCode: "+45",
    flagUrl: "https://flagcdn.com/w20/dk.png",
  },
  {
    code: "DJ",
    name: "Djibouti",
    dialCode: "+253",
    flagUrl: "https://flagcdn.com/w20/dj.png",
  },
  {
    code: "DM",
    name: "Dominica",
    dialCode: "+1",
    flagUrl: "https://flagcdn.com/w20/dm.png",
  },
  {
    code: "DO",
    name: "Dominican Republic",
    dialCode: "+1",
    flagUrl: "https://flagcdn.com/w20/do.png",
  },
  {
    code: "CD",
    name: "DR Congo",
    dialCode: "+243",
    flagUrl: "https://flagcdn.com/w20/cd.png",
  },
  {
    code: "EC",
    name: "Ecuador",
    dialCode: "+593",
    flagUrl: "https://flagcdn.com/w20/ec.png",
  },
  {
    code: "EG",
    name: "Egypt",
    dialCode: "+20",
    flagUrl: "https://flagcdn.com/w20/eg.png",
  },
  {
    code: "SV",
    name: "El Salvador",
    dialCode: "+503",
    flagUrl: "https://flagcdn.com/w20/sv.png",
  },
  {
    code: "GQ",
    name: "Equatorial Guinea",
    dialCode: "+240",
    flagUrl: "https://flagcdn.com/w20/gq.png",
  },
  {
    code: "ER",
    name: "Eritrea",
    dialCode: "+291",
    flagUrl: "https://flagcdn.com/w20/er.png",
  },
  {
    code: "EE",
    name: "Estonia",
    dialCode: "+372",
    flagUrl: "https://flagcdn.com/w20/ee.png",
  },
  {
    code: "SZ",
    name: "Eswatini",
    dialCode: "+268",
    flagUrl: "https://flagcdn.com/w20/sz.png",
  },
  {
    code: "ET",
    name: "Ethiopia",
    dialCode: "+251",
    flagUrl: "https://flagcdn.com/w20/et.png",
  },
  {
    code: "FK",
    name: "Falkland Islands",
    dialCode: "+500",
    flagUrl: "https://flagcdn.com/w20/fk.png",
  },
  {
    code: "FO",
    name: "Faroe Islands",
    dialCode: "+298",
    flagUrl: "https://flagcdn.com/w20/fo.png",
  },
  {
    code: "FJ",
    name: "Fiji",
    dialCode: "+679",
    flagUrl: "https://flagcdn.com/w20/fj.png",
  },
  {
    code: "FI",
    name: "Finland",
    dialCode: "+358",
    flagUrl: "https://flagcdn.com/w20/fi.png",
  },
  {
    code: "FR",
    name: "France",
    dialCode: "+33",
    flagUrl: "https://flagcdn.com/w20/fr.png",
  },
  {
    code: "GF",
    name: "French Guiana",
    dialCode: "+594",
    flagUrl: "https://flagcdn.com/w20/gf.png",
  },
  {
    code: "PF",
    name: "French Polynesia",
    dialCode: "+689",
    flagUrl: "https://flagcdn.com/w20/pf.png",
  },
  {
    code: "TF",
    name: "French Southern and Antarctic Lands",
    dialCode: "+262",
    flagUrl: "https://flagcdn.com/w20/tf.png",
  },
  {
    code: "GA",
    name: "Gabon",
    dialCode: "+241",
    flagUrl: "https://flagcdn.com/w20/ga.png",
  },
  {
    code: "GM",
    name: "Gambia",
    dialCode: "+220",
    flagUrl: "https://flagcdn.com/w20/gm.png",
  },
  {
    code: "GE",
    name: "Georgia",
    dialCode: "+995",
    flagUrl: "https://flagcdn.com/w20/ge.png",
  },
  {
    code: "DE",
    name: "Germany",
    dialCode: "+49",
    flagUrl: "https://flagcdn.com/w20/de.png",
  },
  {
    code: "GH",
    name: "Ghana",
    dialCode: "+233",
    flagUrl: "https://flagcdn.com/w20/gh.png",
  },
  {
    code: "GI",
    name: "Gibraltar",
    dialCode: "+350",
    flagUrl: "https://flagcdn.com/w20/gi.png",
  },
  {
    code: "GR",
    name: "Greece",
    dialCode: "+30",
    flagUrl: "https://flagcdn.com/w20/gr.png",
  },
  {
    code: "GL",
    name: "Greenland",
    dialCode: "+299",
    flagUrl: "https://flagcdn.com/w20/gl.png",
  },
  {
    code: "GD",
    name: "Grenada",
    dialCode: "+1",
    flagUrl: "https://flagcdn.com/w20/gd.png",
  },
  {
    code: "GP",
    name: "Guadeloupe",
    dialCode: "+590",
    flagUrl: "https://flagcdn.com/w20/gp.png",
  },
  {
    code: "GU",
    name: "Guam",
    dialCode: "+1",
    flagUrl: "https://flagcdn.com/w20/gu.png",
  },
  {
    code: "GT",
    name: "Guatemala",
    dialCode: "+502",
    flagUrl: "https://flagcdn.com/w20/gt.png",
  },
  {
    code: "GG",
    name: "Guernsey",
    dialCode: "+44",
    flagUrl: "https://flagcdn.com/w20/gg.png",
  },
  {
    code: "GN",
    name: "Guinea",
    dialCode: "+224",
    flagUrl: "https://flagcdn.com/w20/gn.png",
  },
  {
    code: "GW",
    name: "Guinea-Bissau",
    dialCode: "+245",
    flagUrl: "https://flagcdn.com/w20/gw.png",
  },
  {
    code: "GY",
    name: "Guyana",
    dialCode: "+592",
    flagUrl: "https://flagcdn.com/w20/gy.png",
  },
  {
    code: "HT",
    name: "Haiti",
    dialCode: "+509",
    flagUrl: "https://flagcdn.com/w20/ht.png",
  },
  {
    code: "HM",
    name: "Heard Island and McDonald Islands",
    dialCode: "+672",
    flagUrl: "https://flagcdn.com/w20/hm.png",
  },
  {
    code: "HN",
    name: "Honduras",
    dialCode: "+504",
    flagUrl: "https://flagcdn.com/w20/hn.png",
  },
  {
    code: "HK",
    name: "Hong Kong",
    dialCode: "+852",
    flagUrl: "https://flagcdn.com/w20/hk.png",
  },
  {
    code: "HU",
    name: "Hungary",
    dialCode: "+36",
    flagUrl: "https://flagcdn.com/w20/hu.png",
  },
  {
    code: "IS",
    name: "Iceland",
    dialCode: "+354",
    flagUrl: "https://flagcdn.com/w20/is.png",
  },
  {
    code: "IN",
    name: "India",
    dialCode: "+91",
    flagUrl: "https://flagcdn.com/w20/in.png",
  },
  {
    code: "ID",
    name: "Indonesia",
    dialCode: "+62",
    flagUrl: "https://flagcdn.com/w20/id.png",
  },
  {
    code: "IR",
    name: "Iran",
    dialCode: "+98",
    flagUrl: "https://flagcdn.com/w20/ir.png",
  },
  {
    code: "IQ",
    name: "Iraq",
    dialCode: "+964",
    flagUrl: "https://flagcdn.com/w20/iq.png",
  },
  {
    code: "IE",
    name: "Ireland",
    dialCode: "+353",
    flagUrl: "https://flagcdn.com/w20/ie.png",
  },
  {
    code: "IM",
    name: "Isle of Man",
    dialCode: "+44",
    flagUrl: "https://flagcdn.com/w20/im.png",
  },
  {
    code: "IL",
    name: "Israel",
    dialCode: "+972",
    flagUrl: "https://flagcdn.com/w20/il.png",
  },
  {
    code: "IT",
    name: "Italy",
    dialCode: "+39",
    flagUrl: "https://flagcdn.com/w20/it.png",
  },
  {
    code: "CI",
    name: "Ivory Coast",
    dialCode: "+225",
    flagUrl: "https://flagcdn.com/w20/ci.png",
  },
  {
    code: "JM",
    name: "Jamaica",
    dialCode: "+1",
    flagUrl: "https://flagcdn.com/w20/jm.png",
  },
  {
    code: "JP",
    name: "Japan",
    dialCode: "+81",
    flagUrl: "https://flagcdn.com/w20/jp.png",
  },
  {
    code: "JE",
    name: "Jersey",
    dialCode: "+44",
    flagUrl: "https://flagcdn.com/w20/je.png",
  },
  {
    code: "JO",
    name: "Jordan",
    dialCode: "+962",
    flagUrl: "https://flagcdn.com/w20/jo.png",
  },
  {
    code: "KZ",
    name: "Kazakhstan",
    dialCode: "+7",
    flagUrl: "https://flagcdn.com/w20/kz.png",
  },
  {
    code: "KE",
    name: "Kenya",
    dialCode: "+254",
    flagUrl: "https://flagcdn.com/w20/ke.png",
  },
  {
    code: "KI",
    name: "Kiribati",
    dialCode: "+686",
    flagUrl: "https://flagcdn.com/w20/ki.png",
  },
  {
    code: "XK",
    name: "Kosovo",
    dialCode: "+383",
    flagUrl: "https://flagcdn.com/w20/xk.png",
  },
  {
    code: "KW",
    name: "Kuwait",
    dialCode: "+965",
    flagUrl: "https://flagcdn.com/w20/kw.png",
  },
  {
    code: "KG",
    name: "Kyrgyzstan",
    dialCode: "+996",
    flagUrl: "https://flagcdn.com/w20/kg.png",
  },
  {
    code: "LA",
    name: "Laos",
    dialCode: "+856",
    flagUrl: "https://flagcdn.com/w20/la.png",
  },
  {
    code: "LV",
    name: "Latvia",
    dialCode: "+371",
    flagUrl: "https://flagcdn.com/w20/lv.png",
  },
  {
    code: "LB",
    name: "Lebanon",
    dialCode: "+961",
    flagUrl: "https://flagcdn.com/w20/lb.png",
  },
  {
    code: "LS",
    name: "Lesotho",
    dialCode: "+266",
    flagUrl: "https://flagcdn.com/w20/ls.png",
  },
  {
    code: "LR",
    name: "Liberia",
    dialCode: "+231",
    flagUrl: "https://flagcdn.com/w20/lr.png",
  },
  {
    code: "LY",
    name: "Libya",
    dialCode: "+218",
    flagUrl: "https://flagcdn.com/w20/ly.png",
  },
  {
    code: "LI",
    name: "Liechtenstein",
    dialCode: "+423",
    flagUrl: "https://flagcdn.com/w20/li.png",
  },
  {
    code: "LT",
    name: "Lithuania",
    dialCode: "+370",
    flagUrl: "https://flagcdn.com/w20/lt.png",
  },
  {
    code: "LU",
    name: "Luxembourg",
    dialCode: "+352",
    flagUrl: "https://flagcdn.com/w20/lu.png",
  },
  {
    code: "MO",
    name: "Macau",
    dialCode: "+853",
    flagUrl: "https://flagcdn.com/w20/mo.png",
  },
  {
    code: "MG",
    name: "Madagascar",
    dialCode: "+261",
    flagUrl: "https://flagcdn.com/w20/mg.png",
  },
  {
    code: "MW",
    name: "Malawi",
    dialCode: "+265",
    flagUrl: "https://flagcdn.com/w20/mw.png",
  },
  {
    code: "MY",
    name: "Malaysia",
    dialCode: "+60",
    flagUrl: "https://flagcdn.com/w20/my.png",
  },
  {
    code: "MV",
    name: "Maldives",
    dialCode: "+960",
    flagUrl: "https://flagcdn.com/w20/mv.png",
  },
  {
    code: "ML",
    name: "Mali",
    dialCode: "+223",
    flagUrl: "https://flagcdn.com/w20/ml.png",
  },
  {
    code: "MT",
    name: "Malta",
    dialCode: "+356",
    flagUrl: "https://flagcdn.com/w20/mt.png",
  },
  {
    code: "MH",
    name: "Marshall Islands",
    dialCode: "+692",
    flagUrl: "https://flagcdn.com/w20/mh.png",
  },
  {
    code: "MQ",
    name: "Martinique",
    dialCode: "+596",
    flagUrl: "https://flagcdn.com/w20/mq.png",
  },
  {
    code: "MR",
    name: "Mauritania",
    dialCode: "+222",
    flagUrl: "https://flagcdn.com/w20/mr.png",
  },
  {
    code: "MU",
    name: "Mauritius",
    dialCode: "+230",
    flagUrl: "https://flagcdn.com/w20/mu.png",
  },
  {
    code: "YT",
    name: "Mayotte",
    dialCode: "+262",
    flagUrl: "https://flagcdn.com/w20/yt.png",
  },
  {
    code: "MX",
    name: "Mexico",
    dialCode: "+52",
    flagUrl: "https://flagcdn.com/w20/mx.png",
  },
  {
    code: "FM",
    name: "Micronesia",
    dialCode: "+691",
    flagUrl: "https://flagcdn.com/w20/fm.png",
  },
  {
    code: "MD",
    name: "Moldova",
    dialCode: "+373",
    flagUrl: "https://flagcdn.com/w20/md.png",
  },
  {
    code: "MC",
    name: "Monaco",
    dialCode: "+377",
    flagUrl: "https://flagcdn.com/w20/mc.png",
  },
  {
    code: "MN",
    name: "Mongolia",
    dialCode: "+976",
    flagUrl: "https://flagcdn.com/w20/mn.png",
  },
  {
    code: "ME",
    name: "Montenegro",
    dialCode: "+382",
    flagUrl: "https://flagcdn.com/w20/me.png",
  },
  {
    code: "MS",
    name: "Montserrat",
    dialCode: "+1",
    flagUrl: "https://flagcdn.com/w20/ms.png",
  },
  {
    code: "MA",
    name: "Morocco",
    dialCode: "+212",
    flagUrl: "https://flagcdn.com/w20/ma.png",
  },
  {
    code: "MZ",
    name: "Mozambique",
    dialCode: "+258",
    flagUrl: "https://flagcdn.com/w20/mz.png",
  },
  {
    code: "MM",
    name: "Myanmar",
    dialCode: "+95",
    flagUrl: "https://flagcdn.com/w20/mm.png",
  },
  {
    code: "NA",
    name: "Namibia",
    dialCode: "+264",
    flagUrl: "https://flagcdn.com/w20/na.png",
  },
  {
    code: "NR",
    name: "Nauru",
    dialCode: "+674",
    flagUrl: "https://flagcdn.com/w20/nr.png",
  },
  {
    code: "NP",
    name: "Nepal",
    dialCode: "+977",
    flagUrl: "https://flagcdn.com/w20/np.png",
  },
  {
    code: "NL",
    name: "Netherlands",
    dialCode: "+31",
    flagUrl: "https://flagcdn.com/w20/nl.png",
  },
  {
    code: "NC",
    name: "New Caledonia",
    dialCode: "+687",
    flagUrl: "https://flagcdn.com/w20/nc.png",
  },
  {
    code: "NZ",
    name: "New Zealand",
    dialCode: "+64",
    flagUrl: "https://flagcdn.com/w20/nz.png",
  },
  {
    code: "NI",
    name: "Nicaragua",
    dialCode: "+505",
    flagUrl: "https://flagcdn.com/w20/ni.png",
  },
  {
    code: "NE",
    name: "Niger",
    dialCode: "+227",
    flagUrl: "https://flagcdn.com/w20/ne.png",
  },
  {
    code: "NG",
    name: "Nigeria",
    dialCode: "+234",
    flagUrl: "https://flagcdn.com/w20/ng.png",
  },
  {
    code: "NU",
    name: "Niue",
    dialCode: "+683",
    flagUrl: "https://flagcdn.com/w20/nu.png",
  },
  {
    code: "NF",
    name: "Norfolk Island",
    dialCode: "+672",
    flagUrl: "https://flagcdn.com/w20/nf.png",
  },
  {
    code: "KP",
    name: "North Korea",
    dialCode: "+850",
    flagUrl: "https://flagcdn.com/w20/kp.png",
  },
  {
    code: "MK",
    name: "North Macedonia",
    dialCode: "+389",
    flagUrl: "https://flagcdn.com/w20/mk.png",
  },
  {
    code: "MP",
    name: "Northern Mariana Islands",
    dialCode: "+1",
    flagUrl: "https://flagcdn.com/w20/mp.png",
  },
  {
    code: "NO",
    name: "Norway",
    dialCode: "+47",
    flagUrl: "https://flagcdn.com/w20/no.png",
  },
  {
    code: "OM",
    name: "Oman",
    dialCode: "+968",
    flagUrl: "https://flagcdn.com/w20/om.png",
  },
  {
    code: "PK",
    name: "Pakistan",
    dialCode: "+92",
    flagUrl: "https://flagcdn.com/w20/pk.png",
  },
  {
    code: "PW",
    name: "Palau",
    dialCode: "+680",
    flagUrl: "https://flagcdn.com/w20/pw.png",
  },
  {
    code: "PS",
    name: "Palestine",
    dialCode: "+970",
    flagUrl: "https://flagcdn.com/w20/ps.png",
  },
  {
    code: "PA",
    name: "Panama",
    dialCode: "+507",
    flagUrl: "https://flagcdn.com/w20/pa.png",
  },
  {
    code: "PG",
    name: "Papua New Guinea",
    dialCode: "+675",
    flagUrl: "https://flagcdn.com/w20/pg.png",
  },
  {
    code: "PY",
    name: "Paraguay",
    dialCode: "+595",
    flagUrl: "https://flagcdn.com/w20/py.png",
  },
  {
    code: "PE",
    name: "Peru",
    dialCode: "+51",
    flagUrl: "https://flagcdn.com/w20/pe.png",
  },
  {
    code: "PH",
    name: "Philippines",
    dialCode: "+63",
    flagUrl: "https://flagcdn.com/w20/ph.png",
  },
  {
    code: "PN",
    name: "Pitcairn Islands",
    dialCode: "+870",
    flagUrl: "https://flagcdn.com/w20/pn.png",
  },
  {
    code: "PL",
    name: "Poland",
    dialCode: "+48",
    flagUrl: "https://flagcdn.com/w20/pl.png",
  },
  {
    code: "PT",
    name: "Portugal",
    dialCode: "+351",
    flagUrl: "https://flagcdn.com/w20/pt.png",
  },
  {
    code: "PR",
    name: "Puerto Rico",
    dialCode: "+1",
    flagUrl: "https://flagcdn.com/w20/pr.png",
  },
  {
    code: "QA",
    name: "Qatar",
    dialCode: "+974",
    flagUrl: "https://flagcdn.com/w20/qa.png",
  },
  {
    code: "RE",
    name: "Réunion",
    dialCode: "+262",
    flagUrl: "https://flagcdn.com/w20/re.png",
  },
  {
    code: "CG",
    name: "Republic of the Congo",
    dialCode: "+242",
    flagUrl: "https://flagcdn.com/w20/cg.png",
  },
  {
    code: "RO",
    name: "Romania",
    dialCode: "+40",
    flagUrl: "https://flagcdn.com/w20/ro.png",
  },
  {
    code: "RU",
    name: "Russia",
    dialCode: "+7",
    flagUrl: "https://flagcdn.com/w20/ru.png",
  },
  {
    code: "RW",
    name: "Rwanda",
    dialCode: "+250",
    flagUrl: "https://flagcdn.com/w20/rw.png",
  },
  {
    code: "ST",
    name: "São Tomé and Príncipe",
    dialCode: "+239",
    flagUrl: "https://flagcdn.com/w20/st.png",
  },
  {
    code: "BL",
    name: "Saint Barthélemy",
    dialCode: "+590",
    flagUrl: "https://flagcdn.com/w20/bl.png",
  },
  {
    code: "SH",
    name: "Saint Helena, Ascension and Tristan da Cunha",
    dialCode: "+290",
    flagUrl: "https://flagcdn.com/w20/sh.png",
  },
  {
    code: "KN",
    name: "Saint Kitts and Nevis",
    dialCode: "+1",
    flagUrl: "https://flagcdn.com/w20/kn.png",
  },
  {
    code: "LC",
    name: "Saint Lucia",
    dialCode: "+1",
    flagUrl: "https://flagcdn.com/w20/lc.png",
  },
  {
    code: "MF",
    name: "Saint Martin",
    dialCode: "+590",
    flagUrl: "https://flagcdn.com/w20/mf.png",
  },
  {
    code: "PM",
    name: "Saint Pierre and Miquelon",
    dialCode: "+508",
    flagUrl: "https://flagcdn.com/w20/pm.png",
  },
  {
    code: "VC",
    name: "Saint Vincent and the Grenadines",
    dialCode: "+1",
    flagUrl: "https://flagcdn.com/w20/vc.png",
  },
  {
    code: "WS",
    name: "Samoa",
    dialCode: "+685",
    flagUrl: "https://flagcdn.com/w20/ws.png",
  },
  {
    code: "SM",
    name: "San Marino",
    dialCode: "+378",
    flagUrl: "https://flagcdn.com/w20/sm.png",
  },
  {
    code: "SA",
    name: "Saudi Arabia",
    dialCode: "+966",
    flagUrl: "https://flagcdn.com/w20/sa.png",
  },
  {
    code: "SN",
    name: "Senegal",
    dialCode: "+221",
    flagUrl: "https://flagcdn.com/w20/sn.png",
  },
  {
    code: "RS",
    name: "Serbia",
    dialCode: "+381",
    flagUrl: "https://flagcdn.com/w20/rs.png",
  },
  {
    code: "SC",
    name: "Seychelles",
    dialCode: "+248",
    flagUrl: "https://flagcdn.com/w20/sc.png",
  },
  {
    code: "SL",
    name: "Sierra Leone",
    dialCode: "+232",
    flagUrl: "https://flagcdn.com/w20/sl.png",
  },
  {
    code: "SG",
    name: "Singapore",
    dialCode: "+65",
    flagUrl: "https://flagcdn.com/w20/sg.png",
  },
  {
    code: "SX",
    name: "Sint Maarten",
    dialCode: "+1",
    flagUrl: "https://flagcdn.com/w20/sx.png",
  },
  {
    code: "SK",
    name: "Slovakia",
    dialCode: "+421",
    flagUrl: "https://flagcdn.com/w20/sk.png",
  },
  {
    code: "SI",
    name: "Slovenia",
    dialCode: "+386",
    flagUrl: "https://flagcdn.com/w20/si.png",
  },
  {
    code: "SB",
    name: "Solomon Islands",
    dialCode: "+677",
    flagUrl: "https://flagcdn.com/w20/sb.png",
  },
  {
    code: "SO",
    name: "Somalia",
    dialCode: "+252",
    flagUrl: "https://flagcdn.com/w20/so.png",
  },
  {
    code: "ZA",
    name: "South Africa",
    dialCode: "+27",
    flagUrl: "https://flagcdn.com/w20/za.png",
  },
  {
    code: "GS",
    name: "South Georgia",
    dialCode: "+500",
    flagUrl: "https://flagcdn.com/w20/gs.png",
  },
  {
    code: "KR",
    name: "South Korea",
    dialCode: "+82",
    flagUrl: "https://flagcdn.com/w20/kr.png",
  },
  {
    code: "SS",
    name: "South Sudan",
    dialCode: "+211",
    flagUrl: "https://flagcdn.com/w20/ss.png",
  },
  {
    code: "ES",
    name: "Spain",
    dialCode: "+34",
    flagUrl: "https://flagcdn.com/w20/es.png",
  },
  {
    code: "LK",
    name: "Sri Lanka",
    dialCode: "+94",
    flagUrl: "https://flagcdn.com/w20/lk.png",
  },
  {
    code: "SD",
    name: "Sudan",
    dialCode: "+249",
    flagUrl: "https://flagcdn.com/w20/sd.png",
  },
  {
    code: "SR",
    name: "Suriname",
    dialCode: "+597",
    flagUrl: "https://flagcdn.com/w20/sr.png",
  },
  {
    code: "SJ",
    name: "Svalbard and Jan Mayen",
    dialCode: "+47",
    flagUrl: "https://flagcdn.com/w20/sj.png",
  },
  {
    code: "SE",
    name: "Sweden",
    dialCode: "+46",
    flagUrl: "https://flagcdn.com/w20/se.png",
  },
  {
    code: "CH",
    name: "Switzerland",
    dialCode: "+41",
    flagUrl: "https://flagcdn.com/w20/ch.png",
  },
  {
    code: "SY",
    name: "Syria",
    dialCode: "+963",
    flagUrl: "https://flagcdn.com/w20/sy.png",
  },
  {
    code: "TW",
    name: "Taiwan",
    dialCode: "+886",
    flagUrl: "https://flagcdn.com/w20/tw.png",
  },
  {
    code: "TJ",
    name: "Tajikistan",
    dialCode: "+992",
    flagUrl: "https://flagcdn.com/w20/tj.png",
  },
  {
    code: "TZ",
    name: "Tanzania",
    dialCode: "+255",
    flagUrl: "https://flagcdn.com/w20/tz.png",
  },
  {
    code: "TH",
    name: "Thailand",
    dialCode: "+66",
    flagUrl: "https://flagcdn.com/w20/th.png",
  },
  {
    code: "TL",
    name: "Timor-Leste",
    dialCode: "+670",
    flagUrl: "https://flagcdn.com/w20/tl.png",
  },
  {
    code: "TG",
    name: "Togo",
    dialCode: "+228",
    flagUrl: "https://flagcdn.com/w20/tg.png",
  },
  {
    code: "TK",
    name: "Tokelau",
    dialCode: "+690",
    flagUrl: "https://flagcdn.com/w20/tk.png",
  },
  {
    code: "TO",
    name: "Tonga",
    dialCode: "+676",
    flagUrl: "https://flagcdn.com/w20/to.png",
  },
  {
    code: "TT",
    name: "Trinidad and Tobago",
    dialCode: "+1",
    flagUrl: "https://flagcdn.com/w20/tt.png",
  },
  {
    code: "TN",
    name: "Tunisia",
    dialCode: "+216",
    flagUrl: "https://flagcdn.com/w20/tn.png",
  },
  {
    code: "TR",
    name: "Turkey",
    dialCode: "+90",
    flagUrl: "https://flagcdn.com/w20/tr.png",
  },
  {
    code: "TM",
    name: "Turkmenistan",
    dialCode: "+993",
    flagUrl: "https://flagcdn.com/w20/tm.png",
  },
  {
    code: "TC",
    name: "Turks and Caicos Islands",
    dialCode: "+1",
    flagUrl: "https://flagcdn.com/w20/tc.png",
  },
  {
    code: "TV",
    name: "Tuvalu",
    dialCode: "+688",
    flagUrl: "https://flagcdn.com/w20/tv.png",
  },
  {
    code: "UG",
    name: "Uganda",
    dialCode: "+256",
    flagUrl: "https://flagcdn.com/w20/ug.png",
  },
  {
    code: "UA",
    name: "Ukraine",
    dialCode: "+380",
    flagUrl: "https://flagcdn.com/w20/ua.png",
  },
  {
    code: "AE",
    name: "United Arab Emirates",
    dialCode: "+971",
    flagUrl: "https://flagcdn.com/w20/ae.png",
  },
  {
    code: "GB",
    name: "United Kingdom",
    dialCode: "+44",
    flagUrl: "https://flagcdn.com/w20/gb.png",
  },
  {
    code: "US",
    name: "United States",
    dialCode: "+1",
    flagUrl: "https://flagcdn.com/w20/us.png",
  },
  {
    code: "UM",
    name: "United States Minor Outlying Islands",
    dialCode: "+1",
    flagUrl: "https://flagcdn.com/w20/um.png",
  },
  {
    code: "VI",
    name: "United States Virgin Islands",
    dialCode: "+1",
    flagUrl: "https://flagcdn.com/w20/vi.png",
  },
  {
    code: "UY",
    name: "Uruguay",
    dialCode: "+598",
    flagUrl: "https://flagcdn.com/w20/uy.png",
  },
  {
    code: "UZ",
    name: "Uzbekistan",
    dialCode: "+998",
    flagUrl: "https://flagcdn.com/w20/uz.png",
  },
  {
    code: "VU",
    name: "Vanuatu",
    dialCode: "+678",
    flagUrl: "https://flagcdn.com/w20/vu.png",
  },
  {
    code: "VA",
    name: "Vatican City",
    dialCode: "+39",
    flagUrl: "https://flagcdn.com/w20/va.png",
  },
  {
    code: "VE",
    name: "Venezuela",
    dialCode: "+58",
    flagUrl: "https://flagcdn.com/w20/ve.png",
  },
  {
    code: "VN",
    name: "Vietnam",
    dialCode: "+84",
    flagUrl: "https://flagcdn.com/w20/vn.png",
  },
  {
    code: "WF",
    name: "Wallis and Futuna",
    dialCode: "+681",
    flagUrl: "https://flagcdn.com/w20/wf.png",
  },
  {
    code: "EH",
    name: "Western Sahara",
    dialCode: "+212",
    flagUrl: "https://flagcdn.com/w20/eh.png",
  },
  {
    code: "YE",
    name: "Yemen",
    dialCode: "+967",
    flagUrl: "https://flagcdn.com/w20/ye.png",
  },
  {
    code: "ZM",
    name: "Zambia",
    dialCode: "+260",
    flagUrl: "https://flagcdn.com/w20/zm.png",
  },
  {
    code: "ZW",
    name: "Zimbabwe",
    dialCode: "+263",
    flagUrl: "https://flagcdn.com/w20/zw.png",
  },
];
